import React from 'react'
import './TestimonialsSection.scss'
import Container from 'reactor/components/Grid/ContainerWithWidth'
import BoxItem from 'reactor/components/Box'
import Image from 'reactor/components/Image'
import Slider from "react-slick"
import Heading from './../../../components/heading'

import TestimonialImg from 'assets/images/testimonial.png'

var settings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: true,
};
const testimonials = [ {
        id: 1,
        name: 'حسن الراشدي',
        owner: ' متجر الوان اى شوب‎',
        opinion: 'رواد شركة رائعة وانصح الجميع بالاشتراك مع هذة الشركة خدماتهم غير محدودة وفعلا شركة تستحق الاحترام',
        img: TestimonialImg
    },
    {
        id: 2,
        name: 'حسن الراشدي',
        owner: ' متجر الوان اى شوب‎',
        opinion: 'رواد شركة رائعة وانصح الجميع بالاشتراك مع هذة الشركة خدماتهم غير محدودة وفعلا شركة تستحق الاحترام',
        img: TestimonialImg
    },
    {
        id: 3,
        name: 'حسن الراشدي',
        owner: ' متجر الوان اى شوب‎',
        opinion: 'رواد شركة رائعة وانصح الجميع بالاشتراك مع هذة الشركة خدماتهم غير محدودة وفعلا شركة تستحق الاحترام',
        img: TestimonialImg
    },
    {
        id: 4,
        name: 'حسن الراشدي',
        owner: ' متجر الوان اى شوب‎',
        opinion: 'رواد شركة رائعة وانصح الجميع بالاشتراك مع هذة الشركة خدماتهم غير محدودة وفعلا شركة تستحق الاحترام',
        img: TestimonialImg
    }
]

export default function Testimonials() {

    return (
        <div id="testimonials__section">
            <Container block={"true"}>
                <Heading title="آراء عملائنا"
                    subtitle="تأتينا تعليقات من عملانا بكل شفافية نعرض لمحة منها لكم‎"
                />
                <div className="testimonials__section--slider">
                    <Slider {...settings}> 
                    {/* <For array={testimonials} render={testimonial => ( */}
                        { testimonials.map( testimonial => (
                            <BoxItem key={testimonial.id} className="testimonial__item">
                                <div className="testimonial__item--image">
                                    <Image src={testimonial.img} alt={testimonial.owner} />
                                    <p className="testimonial__item--name">{testimonial.name}</p>
                                    <span className="testimonial__item--owner">{testimonial.owner}</span>
                                </div>
                                <p className="testimonial__item--caption">{testimonial.opinion}</p>
                            </BoxItem>
                        ))}
                    {/* ) } /> */}
                    </Slider>  
                </div>
            </Container>   
        </div>
    )
}